<div class="subscribe-area ptb-100">
  <div class="container">
    <div class="newsletter">
      <h2>{{ 'subscribe.title' | translate }}
      </h2>
      <p>{{ 'subscribe.subtitle' | translate }}</p>
      <form class="newsletter-form" #suscribeForm="ngForm" (ngSubmit)="suscribe(suscribeForm.value)">
        <input  required type="email" name="email" email #email="ngModel" ngModel class="form-control" [attr.placeholder]="'subscribe.placeholder' | translate">
        @if (email.touched && email.errors) {
          <div class="alert alert-danger">
            @if (email.errors.required) {
              <div>{{ 'subscribe.emailRequired' | translate }}</div>
            }
            @if (email.errors.email) {
              <div>{{ 'subscribe.emailInvalid' | translate }}</div>
            }
          </div>
        }
        <button class="btn btn-primary" [class.disabled]="!suscribeForm.valid" type="submit">{{ 'subscribe.submit' | translate }}</button>
      </form>
    </div>
  </div>
</div>
